module.exports = __webpack_public_path__ + "h5/img/biao_2.33898a4b.jpg";